import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';
import CameraControl from 'features/toolbar/toolbar/controls/CameraControl';
import MicControl from 'features/toolbar/toolbar/controls/MicControl';
import RaiseHandControl from 'features/toolbar/toolbar/controls/raise-hand/RaiseHandControl';
import { useRaiseHandControl } from 'features/toolbar/toolbar/controls/raise-hand/useRaiseHandControl';
import LeaveBreakoutControl from 'features/toolbar/toolbar/controls/leave-breakout/LeaveBreakoutControl';
import EndCallControl from 'features/toolbar/toolbar/controls/end-call/EndCallControl';
import {
  Inner,
  MenuFixedItems,
  Root,
  ToolbarBg,
  ToolbarNavRoot,
} from 'features/toolbar/toolbar/styles';
import React, { Fragment } from 'react';
import webrtcAdapter from 'webrtc-adapter';

export const PipToolbar = () => {
  const { hasPermissions } = usePermissions();

  const allowVideoBroadcast = hasPermissions(PermissionTypes.broadcastVideo);
  const allowAudioBroadcast = hasPermissions(PermissionTypes.broadcastAudio);

  const { isFeatureAvailable: raiseHandAvailable } = useRaiseHandControl();

  // Firefox cannot reliably start a broadcast from the PiP window: getUserMedia is deferred
  // while the meeting tab is unfocused, so toggling mic/camera inside PiP does nothing until
  // the user returns to the tab (SAMBA-9078). Hide the broadcast controls in Firefox to avoid
  // that broken state; PiP stays usable for viewing.
  const isFirefox = webrtcAdapter.browserDetails.browser === 'firefox';

  const primaryMenuItems = [];

  if (!isFirefox && (allowVideoBroadcast || allowAudioBroadcast)) {
    primaryMenuItems.push(
      <Fragment key="broadcast-controls">
        {allowVideoBroadcast && <CameraControl />}
        {allowAudioBroadcast && <MicControl />}
      </Fragment>
    );
  }

  if (raiseHandAvailable) {
    primaryMenuItems.push(<RaiseHandControl key="raise-hand-control" />);
  }

  primaryMenuItems.push(<LeaveBreakoutControl key="leave-breakout-control" />);
  primaryMenuItems.push(<EndCallControl key="end-call-control" />);

  return (
    <Root
      placement="bottom"
      orientation="horizontal"
      sx={(theme) => ({
        paddingLeft: theme.layout.innerPadding,
        paddingBottom: theme.layout.innerPadding,
      })}
    >
      <ToolbarBg />
      <Inner orientation="horizontal">
        <ToolbarNavRoot orientation="horizontal">
          <MenuFixedItems orientation="horizontal" style={{ justifyContent: 'center' }}>
            {primaryMenuItems}
          </MenuFixedItems>
        </ToolbarNavRoot>
      </Inner>
    </Root>
  );
};
